import { render, staticRenderFns } from "./PanelCompetitionClassificationsForm.vue?vue&type=template&id=3bf2569a&scoped=true&"
import script from "./PanelCompetitionClassificationsForm.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionClassificationsForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionClassificationsForm.vue?vue&type=style&index=0&id=3bf2569a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2569a",
  null
  
)

export default component.exports